// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3zleD","detailsBorder":"styles_detailsBorder__2AUH-"};